import {
  useEffect,
  useCallback,
  useState,
  useMemo,
  Fragment,
  useRef,
} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useFormik, Form, FormikProvider, Field } from "formik";
import Token from "../../util/Token";
import {
  Stack,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Select,
  FormHelperText,
  Card,
  Switch,
  IconButton,
  Button,
  Autocomplete,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  Chip,
  Paper,
  Collapse,
  IconButton as MuiIconButton,
  Alert,
} from "@mui/material";
import * as Yup from "yup";
import PlusCircleFill from "@iconify/icons-eva/plus-circle-fill";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import downloadFill from "@iconify/icons-eva/download-fill";
import { LoadingButton, TabContext, TabPanel } from "@mui/lab";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useMatch,
  useLocation,
} from "react-router-dom";
import { Icon } from "@iconify/react";
import AlertCircleFill from "@iconify/icons-eva/alert-circle-fill";
import PlusFill from "@iconify/icons-eva/plus-fill";
import TrashOutline from "@iconify/icons-eva/trash-2-outline";
// import Countries from "../../data/countries.json";
import ConnectorType from "../../data/connectorType.json";
import { chargerFormValidationSchema } from "../../util/validationSchemas";
import "../../styles/charger.css";
import { useAccess } from "src/hooks/useAccess.hook";
import {
  ChargerFormTabs,
  NOTIFICATION_CONSTANTS,
  getChargerDefaultValues,
  hideForTabs,
  reportIssuesColumn,
} from "./charger.constants";
import {
  chargerIdUrl,
  chargerUrl,
  getTeamUrl,
  viewLogsUrl,
  logFilterData,
} from "src/react-query/endPoints";
import { Loader } from "../Loader";
import { is } from "src/util/is";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useGetDetail, useMutate, useList } from "src/hooks/useFetch.hook";
import { useDispatch, useSelector } from "react-redux";
import enums, { FEATURE } from "src/util/enums";
import Address from "src/common/components/Address";
import { AMENITIES } from "./charger.constants";
import ImgPreviewModal from "../ImagePreviewModal/ImgPreviewModal";
import { getIcon } from "src/utils/utility";

//actions
import { alertSlice } from "src/store/alert/alert.slice";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { fetchInfinite } from "src/react-query/fetchWithError";
import { LogsData } from "./ViewLogsModal";
import { useMutation } from "@tanstack/react-query";
import { issueImgUpload } from "src/components/ServiceRequest/serviceRequest.hook";
import { fileToBase64 } from "src/utils/fileConvertBase64";
import Map from "src/common/components/Map";
import { OutlinedInput, ImageList, ImageListItem } from "@mui/material";
import { RemoteOperationForm } from "./RemoteOperation/RemoteOperationForm";
import { createYupSchema } from "src/utils/yupCreatorSchema";
import { remoteOperationConfig } from "./RemoteOperation/remoteOperationConfig";

import { remoteOperations } from "./RemoteOperation/remote.constants";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import RemoteOpsStatusModal from "./RemoteOperation/RemoteOpsStatusModal";
import { remoteOpsStatusSlice } from "src/store/remoteOpsStatus/remoteOpsStatus.slice";
import { GridLabel } from "../Transactions/TransactionView";
import { BaseTable } from "../BaseTable/BaseTable";
import axios from "../../util/axios";
import { isValidTimeInterval, fChargerLogDateTime } from "src/utils/formatTime";
import { format } from "date-fns";
import RefreshFill from "@iconify/icons-eva/refresh-fill";
import { downloadCSV } from "src/utils/convertAnddownloadCsv";
import { useDomainConfig } from "src/hooks/useDomainConfig";
import { useTeams } from "src/hooks/useTeams";

const {
  actions: { setAlert },
} = alertSlice;

const initialConnectors = [
  { connectorId: "", kw: "", volt: "", connectorType: "", connectorName: "" },
];

const initialFaq = [{ question: "", answer: "" }];

const downloadRazorPayQR = (url) => {
  const link = document.createElement("a");
  link.download = "PaymentQR.jpeg";
  link.href = url;
  link.click();
};

const downloadCMQR = (value) => {
  const qrCode = document.getElementById(`chargerqr-${value}`);
  const svgData = new XMLSerializer().serializeToString(qrCode);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.onload = () => {
    const padding = 20;
    const widthWithPadding = img.width + padding * 2;
    const heightWithPadding = img.height + padding * 2;
    canvas.width = widthWithPadding;
    canvas.height = heightWithPadding;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, padding, padding);
    const pngFile = canvas.toDataURL("image/jpeg");
    const downloadLink = document.createElement("a");
    downloadLink.download = `${value}.jpeg`;
    downloadLink.href = `${pngFile}`;
    downloadLink.click();
  };
  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};

const downloadUPIQR = (upiText) => {
  // Generate a unique ID for this QR code
  const qrId = `upiqr-${Date.now()}`;
  
  // Create a temporary QR code element
  const tempDiv = document.createElement("div");
  tempDiv.id = qrId;
  tempDiv.style.position = "absolute";
  tempDiv.style.left = "-9999px";
  document.body.appendChild(tempDiv);
  
  // Import QRCode dynamically or use existing one
  // We'll use the same approach as downloadCMQR
  setTimeout(() => {
    const qrCode = document.getElementById(qrId);
    if (qrCode) {
      const svgData = new XMLSerializer().serializeToString(qrCode.querySelector("svg"));
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        const padding = 20;
        const widthWithPadding = img.width + padding * 2;
        const heightWithPadding = img.height + padding * 2;
        canvas.width = widthWithPadding;
        canvas.height = heightWithPadding;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, padding, padding);
        const pngFile = canvas.toDataURL("image/jpeg");
        const downloadLink = document.createElement("a");
        downloadLink.download = "UPI_QR.jpeg";
        downloadLink.href = `${pngFile}`;
        downloadLink.click();
        document.body.removeChild(tempDiv);
      };
      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    }
  }, 100);
  
  // Return the QR code element for rendering
  return qrId;
};

// Enhanced LogsData Component
const EnhancedLogsData = ({
  data,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  hasTimeFilter = false,
}) => {
  const [expandedLogs, setExpandedLogs] = useState({});
  const [filterType, setFilterType] = useState("ALL"); // ALL, INCOMING, OUTGOING
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const toggleLogExpansion = (logIndex) => {
    setExpandedLogs((prev) => ({
      ...prev,
      [logIndex]: !prev[logIndex],
    }));
  };

  const expandAllLogs = () => {
    if (!data?.pages) return;
    const allLogs = data.pages.flat();
    const expandedState = {};
    allLogs.forEach((_, index) => {
      expandedState[index] = true;
    });
    setExpandedLogs(expandedState);
  };

  const collapseAllLogs = () => {
    setExpandedLogs({});
  };

  // Auto-expand all logs when data changes, but only for new data
  useEffect(() => {
    if (data?.pages && data.pages.length > 0) {
      const allLogs = data.pages.flat();
      const expandedState = {};
      allLogs.forEach((_, index) => {
        expandedState[index] = true;
      });
      setExpandedLogs(expandedState);
    }
  }, [data?.pages?.length]); // Only trigger when number of pages changes, not on every data update

  // Handle scroll events to prevent unwanted refreshes
  useEffect(() => {
    const scrollContainer = document.getElementById("logs-scroll-container");
    if (!scrollContainer) return;

    const handleScroll = () => {
      setIsUserScrolling(true);
      // Reset scrolling state after a delay
      setTimeout(() => setIsUserScrolling(false), 1000);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, []);

  const allLogs = useMemo(() => {
    if (!data?.pages) return [];
    return data.pages.flat();
  }, [data]);

  const filteredLogs = useMemo(() => {
    if (filterType === "ALL") return allLogs;
    return allLogs.filter((log) => log.messageType === filterType);
  }, [allLogs, filterType]);

  const incomingCount =
    allLogs?.filter((log) => log.messageType === "INCOMING").length || 0;
  const outgoingCount =
    allLogs?.filter((log) => log.messageType === "OUTGOING").length || 0;

  const expandedCount = Object.values(expandedLogs).filter(Boolean).length;
  const totalLogs = filteredLogs.length;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Filter Controls */}
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <Chip
            label={`All (${incomingCount + outgoingCount})`}
            onClick={() => setFilterType("ALL")}
            color={filterType === "ALL" ? "primary" : "default"}
            variant={filterType === "ALL" ? "filled" : "outlined"}
            size="small"
          />
          <Chip
            label={`Incoming (${incomingCount})`}
            onClick={() => setFilterType("INCOMING")}
            color={filterType === "INCOMING" ? "primary" : "default"}
            variant={filterType === "INCOMING" ? "filled" : "outlined"}
            size="small"
            sx={{
              backgroundColor:
                filterType === "INCOMING" ? "#e3f2fd" : "transparent",
              color: filterType === "INCOMING" ? "#1976d2" : "inherit",
            }}
          />
          <Chip
            label={`Outgoing (${outgoingCount})`}
            onClick={() => setFilterType("OUTGOING")}
            color={filterType === "OUTGOING" ? "primary" : "default"}
            variant={filterType === "OUTGOING" ? "filled" : "outlined"}
            size="small"
            sx={{
              backgroundColor:
                filterType === "OUTGOING" ? "#e8f5e8" : "transparent",
              color: filterType === "OUTGOING" ? "#2e7d32" : "inherit",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Expand/Collapse All Buttons */}
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Button
              size="small"
              variant="outlined"
              onClick={expandAllLogs}
              startIcon={
                <Icon icon="eva:expand-outline" width={16} height={16} />
              }
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontSize: "0.75rem",
                fontWeight: 600,
                px: 1.5,
                py: 0.5,
                minWidth: "auto",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                  borderColor: "#1976d2",
                },
              }}
            >
              Expand All
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={collapseAllLogs}
              startIcon={
                <Icon icon="eva:collapse-outline" width={16} height={16} />
              }
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontSize: "0.75rem",
                fontWeight: 600,
                px: 1.5,
                py: 0.5,
                minWidth: "auto",
                color: "#2e7d32",
                borderColor: "#2e7d32",
                "&:hover": {
                  backgroundColor: "#e8f5e8",
                  borderColor: "#2e7d32",
                  color: "#1b5e20",
                },
              }}
            >
              Collapse All
            </Button>
          </Box>

          {/* Log Statistics */}
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: 500,
              whiteSpace: "nowrap",
              px: 1.5,
              py: 0.5,
              backgroundColor: hasTimeFilter
                ? "rgba(255, 152, 0, 0.1)"
                : "rgba(25, 118, 210, 0.1)",
              borderRadius: 1,
              border: hasTimeFilter
                ? "1px solid rgba(255, 152, 0, 0.2)"
                : "1px solid rgba(25, 118, 210, 0.2)",
            }}
          >
            {hasTimeFilter
              ? "🔍 Filtered Logs (No Auto-refresh)"
              : "📊 Real-time Logs (Auto-refresh)"}{" "}
            |
            {expandedCount > 0 && (
              <span style={{ color: "#1976d2", fontWeight: 600 }}>
                {expandedCount}/{totalLogs} expanded
              </span>
            )}
            {expandedCount === 0 &&
              `Showing ${filteredLogs.length} of ${
                incomingCount + outgoingCount
              } logs`}
          </Typography>
        </Box>
      </Box>

      {/* Logs Container with Infinite Scroll */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          minHeight: "400px",
          maxHeight: "600px",
          maxWidth: "100%",
          width: "100%",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#a8a8a8",
          },
        }}
        id="logs-scroll-container"
      >
        <InfiniteScroll
          dataLength={filteredLogs.length}
          next={() => {
            // Only allow infinite scroll if:
            // 1. There are more pages available
            // 2. Not currently fetching
            // 3. User is not actively scrolling
            // 4. AND either no time filter is applied OR user is viewing real-time logs
            if (
              hasNextPage &&
              !isFetchingNextPage &&
              !isUserScrolling &&
              !hasTimeFilter
            ) {
              fetchNextPage();
            }
          }}
          hasMore={
            hasNextPage &&
            !isFetchingNextPage &&
            !isUserScrolling &&
            !hasTimeFilter
          }
          threshold={300} // Increased threshold to prevent premature triggering
          loader={
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                {hasTimeFilter
                  ? "Time-filtered logs - no auto-refresh"
                  : "Loading more logs..."}
              </Typography>
            </Box>
          }
          scrollableTarget="logs-scroll-container"
          endMessage={
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                {hasTimeFilter
                  ? "End of searched logs - no more data to load"
                  : "No more logs to load"}
              </Typography>
            </Box>
          }
          style={{ overflow: "visible" }} // Prevent scroll issues
        >
          {filteredLogs.map(
            ({ messageTime, messageType, message }, logIndex) => {
              const isExpanded = expandedLogs[logIndex];
              const isIncoming = messageType === "INCOMING";

              return (
                <Paper
                  key={logIndex}
                  elevation={1}
                  sx={{
                    m: 1,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: `2px solid ${isIncoming ? "#e3f2fd" : "#e8f5e8"}`,
                    background: isIncoming
                      ? "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)"
                      : "linear-gradient(135deg, #f8fff8 0%, #e8f5e8 100%)",
                    // Transitions removed
                    maxWidth: "100%",
                    width: "100%",
                    "&:hover": {
                      // Hover effects removed
                    },
                  }}
                >
                  {/* Log Header */}
                  <Box
                    sx={{
                      p: 2,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      minHeight: "60px",
                    }}
                    onClick={() => toggleLogExpansion(logIndex)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flex: 1,
                        minWidth: 0,
                        maxWidth: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {/* Message Type Badge */}
                      <Chip
                        label={messageType}
                        size="small"
                        sx={{
                          backgroundColor: isIncoming ? "#1976d2" : "#2e7d32",
                          color: "white",
                          fontWeight: 600,
                          minWidth: "80px",
                          fontSize: "0.75rem",
                        }}
                      />

                      {/* Timestamp */}
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                          fontSize: "0.8rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {fChargerLogDateTime(messageTime)}
                      </Typography>

                      {/* Message Preview */}
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.primary",
                          fontWeight: 500,
                          flex: 1,
                          minWidth: 0,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          ml: 1,
                          maxWidth: "300px",
                        }}
                      >
                        {message.length > 100
                          ? `${message.substring(0, 100)}...`
                          : message}
                      </Typography>
                    </Box>

                    {/* Expand/Collapse Icon */}
                    <MuiIconButton
                      size="small"
                      sx={{
                        ml: 1,
                        // Rotation animation removed
                        // Transitions removed
                      }}
                    >
                      <Icon
                        icon="eva:arrow-ios-downward-outline"
                        width={20}
                        height={20}
                      />
                    </MuiIconButton>
                  </Box>

                  {/* Expanded Content */}
                  <Collapse in={isExpanded}>
                    <Box
                      sx={{
                        p: 2,
                        pt: 0,
                        borderTop: "1px solid rgba(0,0,0,0.1)",
                        background: "rgba(255,255,255,0.7)",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "monospace",
                          fontSize: "0.8rem",
                          lineHeight: 1.6,
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          color: "text.primary",
                          background: "rgba(0,0,0,0.02)",
                          p: 2,
                          borderRadius: 1,
                          border: "1px solid rgba(0,0,0,0.1)",
                          maxWidth: "100%",
                          overflow: "hidden",
                        }}
                      >
                        {message}
                      </Typography>
                    </Box>
                  </Collapse>
                </Paper>
              );
            }
          )}
        </InfiniteScroll>
      </Box>
    </Box>
  );
};

// Component to display price information for a selected price group
// Fetches individual price group details via API
const PriceGroupPriceDisplay = ({ priceGroupId }) => {
  // Fetch individual price group details
  const { data: priceGroupDetail, isFetching } = useGetDetail("priceGroup", {
    id: priceGroupId,
  });
  
  // Use useMemo to recalculate when priceGroupDetail changes
  const priceInfo = useMemo(() => {
    // Don't calculate if still loading or no price group selected
    if (isFetching || !priceGroupId || !priceGroupDetail) {
      return null;
    }
    
    // Get priceDetails from the fetched data
    const priceDetails = priceGroupDetail.priceDetails || priceGroupDetail.price_details;
    
    if (!Array.isArray(priceDetails) || priceDetails.length === 0) {
      return null;
    }
    
    // Find the first price detail with a valid price value
    const priceDetail = priceDetails.find(detail => {
      const priceType = detail.priceType || detail.price_type;
      const priceperKW = detail.priceperKW || detail.priceper_kw || detail.price_per_kw;
      const priceperHr = detail.priceperHr || detail.priceper_hr || detail.price_per_hr;
      const priceperMin = detail.priceperMin || detail.priceper_min || detail.price_per_min;
      
      if (priceType === enums.PRICE_PER.KWH && priceperKW && parseFloat(priceperKW) > 0) {
        return true;
      } else if ((priceType === enums.PRICE_PER.MIN || priceType === enums.PRICE_PER.HR) && 
                 ((priceperHr && parseFloat(priceperHr) > 0) || (priceperMin && parseFloat(priceperMin) > 0))) {
        return true;
      }
      return false;
    }) || priceDetails[0];
    
    if (!priceDetail) {
      return null;
    }
    
    // Handle different property name variations
    const priceType = priceDetail.priceType || priceDetail.price_type;
    const priceperKW = priceDetail.priceperKW || priceDetail.priceper_kw || priceDetail.price_per_kw;
    const priceperHr = priceDetail.priceperHr || priceDetail.priceper_hr || priceDetail.price_per_hr;
    const priceperMin = priceDetail.priceperMin || priceDetail.priceper_min || priceDetail.price_per_min;
    
    let info = null;
    
    if (priceType === enums.PRICE_PER.KWH && priceperKW) {
      const priceValue = parseFloat(priceperKW);
      if (!isNaN(priceValue) && priceValue > 0) {
        info = {
          type: "kwh",
          value: priceValue,
          label: "Price per kWh",
          currency: priceGroupDetail?.currency || "INR"
        };
      }
    } else if (priceType === enums.PRICE_PER.MIN || priceType === enums.PRICE_PER.HR) {
      // If priceperHr is set, convert to per minute, otherwise use priceperMin
      if (priceperHr && parseFloat(priceperHr) > 0) {
        const pricePerMin = parseFloat(priceperHr) / 60;
        info = {
          type: "min",
          value: pricePerMin,
          label: "Price per minute",
          currency: priceGroupDetail?.currency || "INR"
        };
      } else if (priceperMin && parseFloat(priceperMin) > 0) {
        info = {
          type: "min",
          value: parseFloat(priceperMin),
          label: "Price per minute",
          currency: priceGroupDetail?.currency || "INR"
        };
      }
    }
    
    return info;
  }, [priceGroupId, priceGroupDetail, isFetching]);
  
  if (!priceInfo) {
    return null;
  }
  
  return (
    <Typography
      variant="caption"
      sx={{
        mt: 0.5,
        display: "block",
        color: "text.secondary",
        fontSize: "0.75rem",
      }}
    >
      {priceInfo.label}: {priceInfo.value.toFixed(2)} {priceInfo.currency}
    </Typography>
  );
};

export default function ChargerForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const queryClient = useQueryClient();
  const hasReadOnlyAccess = useAccess(FEATURE.CHARGER, "R");
  const { data: priceGroups, isFetching: isPriceGroupsFetching } = useList("priceGroups");
  const isCreateCharger = useMatch("/charger/new");
  const isReadOnly = hasReadOnlyAccess && !isCreateCharger;
  const { teamId } = useSelectedTeam();
  const [logDetailData, setLogDetailData] = useState();
  const { data: charger, isFetching, error: chargerError } = useGetDetail("charger", { id });
  const [companyId, setCompanyId] = useState(null);
  const [companyType, setCompanyType] = useState("");
  const [userType, setUserType] = useState("");
  const [timeInterval, setTimeInterval] = useState({
    startDate: "",
    endDate: "",
  });
  const [hasTimeFilter, setHasTimeFilter] = useState(false); // Track if user has applied time filter
  const [isDateInputFocused, setIsDateInputFocused] = useState(false); // Track if user is selecting dates
  const hasAutoLoadedRef = useRef(false); // Track if we've already auto-loaded for this tab selection
  const dateInputBlurTimeoutRef = useRef(null); // Store timeout for date input blur

  // Helper function to safely format dates
  const safeFormatDate = (date, formatString) => {
    if (!date || !(date instanceof Date) || isNaN(date)) {
      return "";
    }
    try {
      return format(date, formatString);
    } catch (error) {
      console.warn("Date formatting error:", error);
      return "";
    }
  };

  // Helper function to format date for datetime-local input (displays in local time)
  const formatDateForInput = (date) => {
    if (!date) {
      return "";
    }

    try {
      let dateObj;

      // Check if it's already a Date object
      if (date instanceof Date) {
        dateObj = date;
      } else if (typeof date === "string") {
        // Handle different string formats
        if (date.includes("/")) {
          // Handle DD/MM/YYYY format like "24/09/2025 11:03:18"
          const parts = date.split(" ");
          const datePart = parts[0]; // "24/09/2025"
          const timePart = parts[1] || "00:00:00"; // "11:03:18"

          const [day, month, year] = datePart.split("/");
          const [hours, minutes, seconds] = timePart.split(":");

          // Create Date object (month is 0-indexed)
          dateObj = new Date(year, month - 1, day, hours, minutes, seconds);
        } else {
          // Handle other formats
          dateObj = new Date(date);
        }
      } else {
        return "";
      }

      if (isNaN(dateObj.getTime())) {
        return "";
      }

      // Format the date in local timezone for the datetime-local input
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      const hours = String(dateObj.getHours()).padStart(2, "0");
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
      console.warn("Date formatting error:", error);
      return "";
    }
  };
  const [searchData, setSearchData] = useState(true);
  const [isFetchingLogs, setIsFetchingLogs] = useState(false);
  const domainConfig = useDomainConfig();
  // Fetch teams if companyType is "P"
  useEffect(() => {
    const parsedToken = Token.parsedToken();
    if (parsedToken.success) {
      const { companyType, companyId, userType } = parsedToken.data;
      setCompanyType(companyType);
      setCompanyId(companyId);
      setUserType(userType);
    }
  }, []);

  const { data: teams } = useTeams(companyId);
  
  // Get redux data and selected tab before useInfiniteQuery to avoid initialization errors
  const {
    tabOpened,
    tabOpenedFor,
    data: reduxData,
  } = useSelector(({ tabsCurrentlyOpenedFor }) => tabsCurrentlyOpenedFor);
  const [selectedTab, setSelectedTab] = useState(
    tabOpenedFor === "charger" && tabOpened ? tabOpened : "general"
  );
  
  const {
    data: logsData,
    hasNextPage,
    fetchNextPage,
    refetch,
    isFetching: isLogsFetching,
    isRefetching: isLogsRefetching,
    isFetchingNextPage,
  } = useInfiniteQuery(
    [
      "viewLogs",
      { url: getTeamUrl(teamId, viewLogsUrl(charger?.chargepoint_id)) },
    ],
    fetchInfinite,
    {
      enabled: !!charger && !hasTimeFilter && selectedTab === "logs" && !reduxData?.dataForLogs,
      getNextPageParam: (lastPage, pages) => {
        // If the last page is empty, there are no more pages
        if (lastPage.length === 0) {
          return undefined;
        }
        // Return the next page number
        return pages.length + 1;
      },
    }
  );

  // const handleTeamChange = (event) => {
  //   const selectedTeamId = event.target.value;
  //   setFieldValue("companyId", selectedTeamId); // Update the form's companyId field
  // };

  // // Filter the price groups based on the selected team's companyId
  // const filteredPriceGroups = priceGroups?.filter(
  //   (group) => group.companyId === values.companyId
  // );

  const handleRefetch = async () => {
    setSearchData(true);
    await refetch();
    setLogDetailData(logsData);
  };

  const errorNotification = () => {
    return dispatch(
      setAlert({
        open: true,
        message: "Please select a valid time interval",
        severity: enums.SEVERITY.ERROR,
      })
    );
  };

  useEffect(() => {
    // Don't sync default logs when time-based logs are active
    if (logsData && !hasTimeFilter && !reduxData?.dataForLogs) {
      setLogDetailData(logsData);
    }
  }, [logsData?.pages?.length, hasTimeFilter, reduxData?.dataForLogs]); // Only update when pages change, not on every data update

  function getTime(time) {
    // Handle different time formats
    if (typeof time === "string") {
      // If it's an ISO string (UTC format), extract time from it
      if (time.includes("T") && (time.includes("Z") || time.includes("+"))) {
        // ISO format like "2025-09-24T05:33:18.619Z" or "2025-09-24T05:33:18+00:00"
        const date = new Date(time);
        return date.toLocaleTimeString("en-GB", { hour12: false }); // Format as HH:MM:SS
      }

      // If it's a space-separated format like "2025-09-24 05:33:18.619000"
      if (time.includes(" ")) {
        const timePart = time.split(" ")[1];
        if (timePart) {
          return timePart.split(".")[0]; // Remove milliseconds if present
        }
      }
    }

    // Fallback: treat as any date format and extract time
    let date = new Date(time);
    if (isNaN(date.getTime())) {
      return "00:00:00"; // Return default time if parsing fails
    }
    return date.toLocaleTimeString("en-GB", { hour12: false }); // Format as HH:MM:SS
  }

  const tabsToShow = useMemo(() => {
    if (id) {
      return ChargerFormTabs;
    }
    return ChargerFormTabs.filter(
      (tab) =>
        tab.value !== "config" &&
        tab.value !== "logs" &&
        tab.value !== "remote operations" &&
        tab.value !== "report_incidents"
    );
  }, [id]);

  const { mutate, isLoading } = useMutate("chargers");
  const { mutate: genQRMutate, isLoading: isGenQR } = useMutate("generateQR");
  const { modalOpen, remoteOperationPerformed, operationDetails } = useSelector(
    ({ remoteOpStatus }) => remoteOpStatus
  );
  const downloadUPIQRFromModal = (upiText, logoUrl) => {
    // This function will be called from the modal to download the QR code with logo
    const qrCode = document.getElementById(`upiqr-${upiText.replace(/[^a-zA-Z0-9]/g, '')}`);
    if (qrCode) {
      const svgElement = qrCode.querySelector("svg");
      if (svgElement) {
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = () => {
          const padding = 20;
          const widthWithPadding = img.width + padding * 2;
          const heightWithPadding = img.height + padding * 2;
          canvas.width = widthWithPadding;
          canvas.height = heightWithPadding;
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, padding, padding);
          
          // Add logo overlay in the center if logoUrl is provided
          if (logoUrl) {
            const logoImg = new Image();
            logoImg.crossOrigin = "anonymous";
            logoImg.onload = () => {
              const logoSize = Math.min(img.width, img.height) * 0.2; // 20% of QR code size
              const logoX = padding + (img.width / 2) - (logoSize / 2);
              const logoY = padding + (img.height / 2) - (logoSize / 2);
              
              // Draw white background for logo
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10);
              
              // Draw logo
              ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize);
              
              // Download the final image
              const pngFile = canvas.toDataURL("image/jpeg");
              const downloadLink = document.createElement("a");
              downloadLink.download = "UPI_QR.jpeg";
              downloadLink.href = `${pngFile}`;
              downloadLink.click();
            };
            logoImg.onerror = () => {
              // If logo fails to load, download without logo
              const pngFile = canvas.toDataURL("image/jpeg");
              const downloadLink = document.createElement("a");
              downloadLink.download = "UPI_QR.jpeg";
              downloadLink.href = `${pngFile}`;
              downloadLink.click();
            };
            logoImg.src = logoUrl;
          } else {
            // Download without logo
            const pngFile = canvas.toDataURL("image/jpeg");
            const downloadLink = document.createElement("a");
            downloadLink.download = "UPI_QR.jpeg";
            downloadLink.href = `${pngFile}`;
            downloadLink.click();
          }
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
      }
    }
  };

  const [razorPayQRCodePreview, setRazorPayQRCodePreview] = useState({
    type: "payment",
    open: false,
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadRazorPayQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setRazorPayQRCodePreview({ ...razorPayQRCodePreview, open: false });
        },
      },
    ],
  });

  useEffect(() => {
    // Only process if we have transaction data, charger is loaded, and logs tab is selected
    if (reduxData?.dataForLogs && charger && selectedTab === "logs" && !hasAutoLoadedRef.current) {
      let startTime = reduxData.dataForLogs.starttime;
      let stopTime = reduxData.dataForLogs.stoptime
        ? reduxData.dataForLogs.stoptime
        : safeFormatDate(new Date(), "yyyy-MM-dd hh:mm:ss a");


      // Convert string dates to Date objects for the time interval state (for display)
      let startDate = "";
      let endDate = "";

      if (startTime) {
        if (typeof startTime === "string" && startTime.includes("/")) {
          // Handle DD/MM/YYYY format like "24/09/2025 11:03:18"
          const parts = startTime.split(" ");
          const datePart = parts[0]; // "24/09/2025"
          const timePart = parts[1] || "00:00:00"; // "11:03:18"

          const [day, month, year] = datePart.split("/");
          const [hours, minutes, seconds] = timePart.split(":");

          // Create Date object (month is 0-indexed)
          startDate = new Date(year, month - 1, day, hours, minutes, seconds);
        } else {
          startDate = new Date(startTime);
        }
      }

      if (stopTime) {
        if (typeof stopTime === "string" && stopTime.includes("/")) {
          // Handle DD/MM/YYYY format like "24/09/2025 17:46:37"
          const parts = stopTime.split(" ");
          const datePart = parts[0]; // "24/09/2025"
          const timePart = parts[1] || "00:00:00"; // "17:46:37"

          const [day, month, year] = datePart.split("/");
          const [hours, minutes, seconds] = timePart.split(":");

          // Create Date object (month is 0-indexed)
          endDate = new Date(year, month - 1, day, hours, minutes, seconds);
        } else {
          endDate = new Date(stopTime);
        }
      }

      setTimeInterval((prev) => ({ startDate, endDate }));

      // Don't auto-load if user is actively selecting dates
      if (!isDateInputFocused) {
        // Mark as loaded before calling to prevent duplicate calls
        hasAutoLoadedRef.current = true;
        // Set time filter as active when time is prepopulated
        setHasTimeFilter(true);
        // Pass Date objects for API call - fetchLogFilterData will handle UTC conversion
        fetchLogFilterData(startDate, endDate);
      }
    }
  }, [reduxData, selectedTab, charger, isDateInputFocused]);

  // Reset auto-load flag when tab changes or when transaction data changes
  useEffect(() => {
    hasAutoLoadedRef.current = false;
    // Clear any pending blur timeout when tab changes
    if (dateInputBlurTimeoutRef.current) {
      clearTimeout(dateInputBlurTimeoutRef.current);
      dateInputBlurTimeoutRef.current = null;
    }
  }, [selectedTab, reduxData?.dataForLogs]);

  // Automatically load logs when logs tab is selected (fallback for non-transaction cases)
  useEffect(() => {
    // Don't auto-load if user is actively selecting dates or if we've already loaded
    if (isDateInputFocused || hasAutoLoadedRef.current) {
      return;
    }

    // Skip if transaction data exists (handled by the above useEffect)
    if (reduxData?.dataForLogs) {
      return;
    }

    if (selectedTab === "logs" && charger) {
      // If there's already a time interval set, automatically fetch logs
      if (timeInterval.startDate && timeInterval.endDate) {
        // Set time filter as active when time interval is already set
        setHasTimeFilter(true);
        fetchLogFilterData(timeInterval.startDate, timeInterval.endDate);
        hasAutoLoadedRef.current = true;
      } else {
        // Otherwise, just refetch the default logs (without time filter)
        refetch();
        hasAutoLoadedRef.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab, charger, refetch, reduxData, isDateInputFocused, timeInterval.startDate, timeInterval.endDate]);

  const fetchLogFilterData = async (sDate, eDate) => {
    // Convert input dates to proper format for API
    let startDate = "";
    let endDate = "";
    let timeStart = "00:00:00";
    let timeEnd = "00:00:00";

    if (sDate && sDate !== "") {
      // Convert local time to UTC for API
      startDate = safeFormatDate(sDate, "yyyy-MM-dd");
      const utcHours = sDate.getUTCHours().toString().padStart(2, "0");
      const utcMinutes = sDate.getUTCMinutes().toString().padStart(2, "0");
      const utcSeconds = "00"; // Set seconds to 00 for logs API
      timeStart = `${utcHours}:${utcMinutes}:${utcSeconds}`;
    } else if (eDate && eDate !== "") {
      const endDateObj = eDate;
      startDate = safeFormatDate(endDateObj, "yyyy-MM-dd");
    }

    if (eDate && eDate !== "") {
      // Convert local time to UTC for API
      endDate = safeFormatDate(eDate, "yyyy-MM-dd");
      const utcHours = eDate.getUTCHours().toString().padStart(2, "0");
      const utcMinutes = eDate.getUTCMinutes().toString().padStart(2, "0");
      const utcSeconds = "00"; // Set seconds to 00 for logs API
      timeEnd = `${utcHours}:${utcMinutes}:${utcSeconds}`;
    }

    if (
      startDate &&
      endDate &&
      isValidTimeInterval({ start: startDate, end: endDate })
    ) {
      setSearchData(false);
      setIsFetchingLogs(true);

      try {
        const response = await axios.get(
          logFilterData(
            teamId,
            charger.chargepoint_id,
            startDate,
            endDate,
            timeStart,
            timeEnd
          )
        );
        if (response.data) {
          setLogDetailData((prev) => ({
            ...prev,
            pages: [response.data.data],
          }));
        }
      } catch (error) {
        // Error handled silently
      } finally {
        setIsFetchingLogs(false);
      }
    } else errorNotification();
  };

  const [CMQRCodePreview, setCMQRCodePreview] = useState({
    type: "charger",
    open: false,
    templateVal: `${domainConfig.mapUrl}/charger/`,
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadCMQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setCMQRCodePreview({ ...CMQRCodePreview, open: false });
        },
      },
    ],
  });

  const hasConnectorsAdded = useCallback((connectors = []) => {
    return connectors.some(
      (connector) =>
        (connector.volt !== "" && connector.connectorType !== "") ||
        (connector.kw !== "" && connector.connectorType !== "")
    );
  }, []);

  const handleRemoteOpsStatusModalClose = () => {
    dispatch(
      remoteOpsStatusSlice.actions.setRemoteOps({
        open: false,
        remoteOperationPerformed: null,
        operationDetails: { chargerId: null, response: null },
      })
    );
  };

  const onSubmit = (chargerData, { setSubmitting }) => {
    let hasConnectors = !0;
    const {
      actions: { setAlert },
    } = alertSlice;

    // Ensure isActive cannot be disabled once enabled
    if (charger?.status === "A" && !chargerData.isActive) {
      chargerData.isActive = true;
    }
    const {
      street,
      houseNumber,
      zipcode,
      city,
      country,
      state,
      connectors,
      locationLatitude,
      locationLongitude,
    } = chargerData;
    if (is.empty(locationLatitude) || is.empty(locationLongitude)) {
      dispatch(
        setAlert({
          open: true,
          message: "Address is required for the Charge Point",
          severity: enums.SEVERITY.ERROR,
        })
      );
      setSubmitting(false);
      return;
    }
    chargerData.address = {
      street,
      houseNumber,
      zipcode,
      city,
      country,
      state,
    };
    chargerData.employeeOrResident = Number(chargerData.employeeOrResident);
    chargerData.payWithWallet = Number(chargerData.payWithWallet);
    chargerData.payWithCard = Number(chargerData.payWithCard);
    // Ensure isActive value is preserved and not changed once enabled
    chargerData.isActive = Boolean(chargerData.isActive);
    // Set charger_category based on showOnPortal value
    // If showOnPortal is true, set to "paid", otherwise keep existing value or set to "free"
    // if (chargerData.showOnPortal) {
    //   chargerData.charger_category = "paid";
    // } else if (!chargerData.charger_category) {
    //   chargerData.charger_category = "free";
    // }
    chargerData.notificationSettings = {
      notificationRecipients: chargerData.notificationRecipients,
      enableNotifications: Number(chargerData.enableNotifications),
      OcppStationBooted: Number(chargerData.OcppStationBooted),
      OcppStationStatusFailure: Number(chargerData.OcppStationStatusFailure),
      OcppStationWebSocketConnected: Number(
        chargerData.OcppStationWebSocketConnected
      ),
      OcppStationWebSocketDisconnected: Number(
        chargerData.OcppStationWebSocketDisconnected
      ),
      OcppTransactionStarted: Number(chargerData.OcppTransactionStarted),
      OcppTransactionEnded: Number(chargerData.OcppTransactionEnded),
    };
    const mutateObject = {
      url: getTeamUrl(teamId, chargerUrl),
      method: "POST",
    };
    if (!is.nullOrUndefined(id) && !isCreateCharger) {
      // update charger point if id is undefined
      mutateObject.method = "PUT";
      mutateObject.url = getTeamUrl(teamId, chargerIdUrl(id));
    }

    if (connectors.length === 1) {
      hasConnectors = hasConnectorsAdded(connectors);
      if (!hasConnectors) {
        dispatch(
          setAlert({
            open: true,
            message: "At least 1 connector is required",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
    }

    if (connectors.length > 0 && hasConnectors) {
      const arePricegroupsPresent = connectors.every(
        ({ priceGroupId }) => !is.empty(priceGroupId)
      );
      if (!arePricegroupsPresent) {
        //TO CHECK WHETHER ALL THE CONNECTORS HAVE A PRICEGROUP SELECTED
        dispatch(
          setAlert({
            open: true,
            message:
              "Every connector should have a pricegroup specified for it",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
      chargerData.connectors = connectors.map((connector, index) => {
        if (!connector?.connectorName) {
          connector["connectorName"] = index + 1;
        }
        return { ...connector, connectorId: index + 1 };
      });
    }

    chargerData.photos = !is.empty(chargerData.photos)
      ? chargerData.photos.filter((photo) => !is.empty(photo))
      : [];
    chargerData.amenities = !is.empty(chargerData.amenities)
      ? chargerData.amenities.filter((amenity) => !is.empty(amenity))
      : [];
    chargerData.chargepoint_id = chargerData.chargepoint_id.trim();
    mutate(
      {
        url: mutateObject.url,
        method: mutateObject.method,
        body: chargerData,
      },
      {
        onSuccess: (data) => {
          setSubmitting(false);
          dispatch(
            tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
              detailsId: "",
              tabOpenedFor: "",
              tabOpened: "",
              data: {},
            })
          );
          navigate("/charger");
        },
        onError: (error) => {
          console.error("ChargerForm: Error submitting charger data:", {
            error: error,
            errorMessage: error?.message,
            errorResponse: error?.response,
            errorData: error?.response?.data,
            stack: error?.stack,
            chargerData: {
              chargepoint_id: chargerData.chargepoint_id,
              chargepoint_name: chargerData.chargepoint_name,
              companyId: chargerData.companyId,
            },
            url: mutateObject.url,
            method: mutateObject.method,
          });

          // Extract error message from different possible sources
          let errorMessage = "Failed to save charger data";
          if (error?.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error?.response?.data?.error) {
            errorMessage = error.response.data.error;
          } else if (error?.message) {
            errorMessage = error.message;
          } else if (typeof error === "string") {
            errorMessage = error;
          }

          setSubmitting(false);
          dispatch(
            alertSlice.actions.setAlert({
              open: true,
              message: errorMessage,
              severity: enums.SEVERITY.ERROR,
            })
          );
        },
      }
    );
  };

  // Prepare initial values based on whether we're editing or creating
  const getInitialValues = () => {
    if (charger && !isCreateCharger) {
      // For edit mode, use charger data
      const {
        address,
        notificationSettings,
        employeeOrResident,
        payWithWallet,
        payWithCard,
        status,
        connectors,
        ...rest
      } = charger;
      const { zipcode } = address;

      const updatedConnectors = connectors.map((connector) => ({
        ...connector,
        status: status === "NA" ? "Unavailable" : connector.status,
      }));

      const visibiltyOnPortal = !!charger.showOnPortal;
      const preparingState = !!charger.preparingState;

      let formValues = {
        ...rest,
        ...address,
        showOnPortal: visibiltyOnPortal,
        preparingState: preparingState,
        zipcode: zipcode,
        employeeOrResident: !!employeeOrResident,
        payWithWallet: !!payWithWallet,
        payWithCard: !!payWithCard,
        status: status === "A" ? "Active" : "Inactive",
        isActive: status === "A",
        connectors: updatedConnectors,
        charger_category: charger.charger_category || "paid",
        access_level: charger.access_level || "Public",
        photos: charger.photos || [],
        tolerance_watt: charger.tolerance_watt || 300,
        meter_interval_sec: charger.meter_interval_sec || 30,
      };

      // Handle notification settings
      if (notificationSettings) {
        const {
          settings_pk,
          enableNotifications,
          notificationFeatures,
          notificationRecipients,
        } = notificationSettings;

        let allNotificationFeatures;
        if (!is.empty(notificationFeatures)) {
          const selectedFeatures = notificationFeatures.split(",");
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              if (selectedFeatures.includes(feature)) {
                allNotificationFeatures[feature] = true;
              }
              return allNotificationFeatures;
            },
            {}
          );
        } else {
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              return allNotificationFeatures;
            },
            {}
          );
        }

        formValues = {
          ...formValues,
          ...allNotificationFeatures,
          settings_pk,
          notificationRecipients,
          enableNotifications: !!enableNotifications,
        };
      } else {
        formValues = {
          ...formValues,
          enableNotifications: false,
          notificationRecipients: "",
          OcppStationBooted: false,
          OcppStationStatusFailure: false,
          OcppStationWebSocketConnected: false,
          OcppStationWebSocketDisconnected: false,
          OcppTransactionStarted: false,
          OcppTransactionEnded: false,
        };
      }

      return formValues;
    }
    // For create mode, use default values
    return getChargerDefaultValues({ teamId });
  };

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema: chargerFormValidationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  // Helper function to determine if validation errors should be shown
  const shouldShowError = (fieldName) => {
    // Only show errors if field has been touched or form is submitting
    return (touched[fieldName] || isSubmitting) && errors[fieldName];
  };

  // Helper function to determine if form-level errors should be shown
  const shouldShowFormErrors = () => {
    // Only show errors if any field has been touched or form is submitting
    return (
      (Object.keys(touched).length > 0 || isSubmitting) &&
      Object.keys(errors).length > 0
    );
  };

  // Manual validation trigger for field changes
  const handleFieldChange = (fieldName, value) => {
    setFieldValue(fieldName, value);
    // Trigger validation for this field
    formik.validateField(fieldName);
  };

  // Reset form when charger data is loaded
  useEffect(() => {
    if (charger && !isCreateCharger) {
      const initialValues = getInitialValues();
      resetForm({
        values: initialValues,
        errors: {},
        touched: {},
      });
    }
  }, [charger, isCreateCharger, resetForm]);

  // Prevent isActive from being disabled once enabled
  useEffect(() => {
    if (values && values.isActive === false && charger?.status === "A") {
      // If the charger is active on the server but form shows inactive, correct it
      setFieldValue("isActive", true);
    }
  }, [values?.isActive, charger?.status, setFieldValue]);

  const handleAddAndDeleteConnectors = (key = null) => {
    const { connectors } = values;
    if (is.null(key) && connectors.length !== 4) {
      setFieldValue("connectors", connectors.concat(initialConnectors));
    }
    if (!is.null(key)) {
      setFieldValue(
        "connectors",
        connectors.filter((c, i) => i !== key)
      );
    }
  };

  const handleAddAndDeleteFAQ = (key = null) => {
    const { faq } = values;
    if (is.null(key) && faq.length !== 10) {
      setFieldValue("faq", faq.concat(initialFaq));
    }

    if (!is.null(key)) {
      setFieldValue(
        "faq",
        faq.filter((c, i) => i !== key)
      );
    }
  };

  const handleShowRazorPayQRCode = (QRCodeUrl) => {
    // Check if QRCodeUrl starts with "upi://"
    const isUPIProtocol = QRCodeUrl && typeof QRCodeUrl === 'string' && QRCodeUrl.startsWith('upi://');
    
    // Get logo URL from domain config
    const logoUrl = domainConfig?.logoUrl || '/logo/amikCharge.svg';
    const fullLogoUrl = logoUrl.startsWith('http') 
      ? logoUrl 
      : `${window.location.origin}${logoUrl.startsWith('/') ? logoUrl : '/' + logoUrl}`;
    
    const updatedPreviewObject = {
      ...razorPayQRCodePreview,
      value: QRCodeUrl,
      type: isUPIProtocol ? "upi" : "payment",
      logoUrl: isUPIProtocol ? fullLogoUrl : undefined, // Only add logo for UPI QR codes
      open: true,
    };
    setRazorPayQRCodePreview(updatedPreviewObject);
  };

  const handleShowCMQRCode = (chargerId) => {
    const updatedPreviewObject = {
      ...CMQRCodePreview,
      value: chargerId,
      open: true,
    };
    setCMQRCodePreview(updatedPreviewObject);
  };

  const generateQRCode = (connectorId) => {
    genQRMutate(
      {
        url: getTeamUrl(
          teamId,
          `/charger/${charger?.chargepoint_id}/generateQr`
        ),
        method: "POST",
        body: { connectorId, companyId: charger.companyId },
      },
      { onSuccess: () => queryClient.invalidateQueries("charger") }
    );
  };

  // Address tab helper functions
  const imageUploadInputRef = useRef();
  const imgUpload = useMutation(issueImgUpload);
  const [imageUploadPending, setImageUploadPending] = useState(false);

  const handlePlacesChanged = (places) => {
    const {
      address_components,
      geometry: { location },
      formatted_address,
    } = places[0];
    if (address_components) {
      for (let component of address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "country":
            setFieldValue("country", component.short_name);
            break;
          case "locality":
            setFieldValue("city", component.long_name);
            break;
          case "administrative_area_level_1":
            setFieldValue("state", component.long_name);
            break;
          case "postal_code":
            setFieldValue("zipCode", component.long_name);
            break;
          default:
        }
      }
      setFieldValue("street", formatted_address);
      setFieldValue("locationLatitude", location.lat());
      setFieldValue("locationLongitude", location.lng());
    }
  };

  const handleAmenitiesChange = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(
      "amenities",
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    const base64 = [];
    setImageUploadPending(true);
    for (let file of files) {
      base64.push(await fileToBase64(file));
    }

    base64.forEach((b) => {
      imgUpload.mutate(
        {
          image: b,
        },
        {
          onSuccess: (response) => {
            setImageUploadPending(false);
            const photos = values.photos.concat([response.data.data]);
            setFieldValue("photos", photos);
          },
          onError: (error) => {
            console.error("ChargerForm: Error uploading image:", {
              error: error.message,
              stack: error.stack,
              chargepoint_id: values.chargepoint_id,
            });
            setImageUploadPending(false);
            dispatch(
              alertSlice.actions.setAlert({
                open: true,
                message: "Failed to upload image",
                severity: enums.SEVERITY.ERROR,
              })
            );
          },
        }
      );
    });
  };

  // Handle Redux state updates when charger data changes
  useEffect(() => {
    if (charger && priceGroups) {
      const { status, connectors } = charger;

      // update connector status for Inactive Chargers
      const updatedConnectors = connectors.map((connector) => ({
        ...connector,
        status: status === "NA" ? "Unavailable" : connector.status,
      }));
      const reduxData = { ...charger, connectors: updatedConnectors };
      dispatch(
        tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
          detailsId: charger.chargepoint_id,
          tabOpenedFor: "charger",
          tabOpened,
          data: reduxData,
        })
      );
    }
  }, [charger, priceGroups, dispatch, tabOpened]);

  const handleTabChange = (e, tab) => {
    setSelectedTab(tab);
  };

  /*
  REMOTE OPERATIONS ESSENTIALS
  */
  const [operation, setOperation] = useState("ChangeAvailability");

  const validationSchema = useMemo(() => {
    const schema =
      remoteOperationConfig[operation]?.reduce(createYupSchema, {}) ?? {};
    return operation && Yup.object().shape(schema);
  }, [operation]);

  const initialValues = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { fieldName, value }) => ({ ...acc, [fieldName]: value ?? "" }),
        {}
      ) ?? {};
    return values;
  }, [operation]);

  const queryKeysDropdown = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { queryKey, usePk, useEmail }) => {
          return queryKey ? [...acc, { queryKey, usePk, useEmail }] : acc;
        },
        []
      ) ?? [];
    return values;
  }, [operation]);

  // Handle navigation when charger is not found
  useEffect(() => {
    if (!isFetching && !isCreateCharger && is.empty(charger)) {
      navigate("/dashboard");
    }
  }, [isFetching, isCreateCharger, charger, navigate]);

  if (isFetching) {
    return <Loader />;
  }

  if (!isCreateCharger && is.empty(charger)) {
    return null;
  }

  function convertArrayOfObjectsToCSV(arrayOfObjects) {
    if (
      !arrayOfObjects ||
      !Array.isArray(arrayOfObjects) ||
      arrayOfObjects.length === 0
    ) {
      return "";
    }
    const csvContent = arrayOfObjects.map((objects) => {
      const rows = objects.map((object) => {
        const values = Object.values(object).map((value) => `"${value}"`);
        return values.join("; ");
      });
      return rows.join("\n");
    });

    return csvContent.join("\n\n");
  }

  const handleExport = () => {
    const csv = convertArrayOfObjectsToCSV(logsData.pages);
    downloadCSV(csv, "Logs");
  };

  return (
    <>
      <TabContext value={selectedTab}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            mb: 2,
          }}
        >
          <RootTabStyle
            indicatorColor="transparent"
            centered
            length={tabsToShow.length}
            onChange={handleTabChange}
            sx={{
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            {tabsToShow.map((tab) => (
              <RootTabItemStyles
                key={tab.value}
                value={tab.value}
                label={tab.label}
              />
            ))}
          </RootTabStyle>
        </Box>
        <Card
          sx={{
            p: 1.5,
            width: "100%",
            maxWidth: "100%",
            overflow: "visible",
          }}
        >
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              id="charger"
              noValidate
              onSubmit={handleSubmit}
            >
              {/* Display validation errors */}
              {shouldShowFormErrors() && (
                <Box sx={{ mb: 2 }}>
                  <Alert severity="error" sx={{ mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      Please fix the following errors:
                    </Typography>
                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                      {Object.entries(errors).map(([field, error]) => (
                        <li key={field}>
                          <Typography variant="body2">{error}</Typography>
                        </li>
                      ))}
                    </ul>
                  </Alert>
                </Box>
              )}

              <TabPanel value="general">
                {/* Main Content Grid - Single Column Layout */}
                <Grid container spacing={2}>
                  {/* Basic Information */}
                  <Grid item xs={12}>
                    <Card
                      sx={{ p: 2, display: "flex", flexDirection: "column" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            display: "flex",
                            alignItems: "center",
                            "&::before": {
                              content: '""',
                              width: 4,
                              height: 20,
                              backgroundColor: "primary.main",
                              borderRadius: 2,
                              mr: 1.5,
                            },
                          }}
                        >
                          Basic Information
                        </Typography>

                        {/* Charger QR Download Button - Only for existing chargers */}
                        {!isCreateCharger && (
                          <LoadingButton
                            size="medium"
                            type="button"
                            variant="contained"
                            startIcon={getIcon(downloadFill, 18, 18)}
                            onClick={() =>
                              handleShowCMQRCode(values["chargepoint_id"])
                            }
                            sx={{
                              background:
                                "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                              boxShadow: "0 6px 20px rgba(46, 125, 50, 0.4)",
                              fontWeight: 700,
                              fontSize: "0.875rem",
                              px: 3,
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              minHeight: "44px",
                              border: "2px solid transparent",
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)",
                                boxShadow: "0 8px 25px rgba(46, 125, 50, 0.5)",
                                transform: "translateY(-2px)",
                                border: "2px solid rgba(255, 255, 255, 0.2)",
                              },
                              "&:active": {
                                transform: "translateY(0px)",
                              },
                              transition:
                                "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                          >
                            Charger QR
                          </LoadingButton>
                        )}
                      </Box>

                      <Grid container spacing={2} sx={{ flex: 1 }}>
                        {/* Row 1: Chargebox ID and Name */}
                        <Grid item xs={12} sm={6}>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="flex-start"
                          >
                            <FormControl fullWidth size="small">
                              <TextField
                                required
                                disabled={isReadOnly}
                                label="Chargebox ID"
                                size="small"
                                {...getFieldProps("chargepoint_id")}
                                error={Boolean(
                                  shouldShowError("chargepoint_id")
                                )}
                                helperText={shouldShowError("chargepoint_id")}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: 2,
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "primary.main",
                                      },
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  },
                                }}
                              />
                            </FormControl>
                            <Tooltip
                              title="Unique identifier for system management"
                              placement="right"
                              arrow
                            >
                              <IconButton
                                size="small"
                                sx={{
                                  mt: 1,
                                  color: "text.secondary",
                                  "&:hover": {
                                    color: "primary.main",
                                    backgroundColor: "primary.lighter",
                                  },
                                }}
                              >
                                <Icon
                                  icon={AlertCircleFill}
                                  width={16}
                                  height={16}
                                />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(shouldShowError("chargepoint_name"))}
                          >
                            <TextField
                              required
                              disabled={isReadOnly}
                              label="Chargebox Name"
                              size="small"
                              {...getFieldProps("chargepoint_name")}
                              error={Boolean(
                                shouldShowError("chargepoint_name")
                              )}
                              helperText={shouldShowError("chargepoint_name")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: 2,
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "primary.main",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 600,
                                  color: "text.secondary",
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>

                        {/* Row 2: Charger Type and Registration Status */}
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(
                              touched.charger_type && errors.charger_type
                            )}
                          >
                            <InputLabel
                              id="chargerType"
                              sx={{ fontWeight: 600, color: "text.secondary" }}
                            >
                              Charger Type *
                            </InputLabel>
                            <Select
                              labelId="chargerType"
                              id={`chargerTypeId-${values.charger_type}`}
                              disabled={isReadOnly}
                              label="Charger Type"
                              {...getFieldProps("charger_type")}
                              sx={{
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "primary.main",
                                },
                              }}
                            >
                              <MenuItem value="AC">AC</MenuItem>
                              <MenuItem value="DC">DC</MenuItem>
                            </Select>
                            {touched.charger_type && (
                              <FormHelperText>
                                {errors.charger_type}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(
                              touched.registrationStatus &&
                                errors.registrationStatus
                            )}
                          >
                            <InputLabel
                              id="registrationStatus"
                              sx={{ fontWeight: 600, color: "text.secondary" }}
                            >
                              Registration Status *
                            </InputLabel>
                            <Select
                              labelId="registrationStatus"
                              id="registrationStatus"
                              disabled={isReadOnly}
                              label="Registration Status"
                              {...getFieldProps("registrationStatus")}
                              sx={{
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "primary.main",
                                },
                              }}
                            >
                              <MenuItem selected value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="Pending">Pending</MenuItem>
                              <MenuItem value="Accepted">Accepted</MenuItem>
                              <MenuItem value="Rejected">Rejected</MenuItem>
                            </Select>
                            {touched.registrationStatus && (
                              <FormHelperText>
                                {errors.registrationStatus}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>

                {/* {companyType.toUpperCase() === "P" &&
                  userType.toUpperCase() === "ROOT" && (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={6} lg={6}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={Boolean(touched.teamId && errors.teamId)}
                        >
                          <InputLabel
                            id="team-select-label"
                            sx={{ background: "#fff", px: 0.5 }}
                          >
                            Select Team
                          </InputLabel>
                          <Select
                            labelId="team-select-label"
                            id="team-select"
                            disabled={isReadOnly || !Array.isArray(teams?.data)}
                            {...getFieldProps("companyId")}
                          >
                            {Array.isArray(teams?.data) &&
                              teams.data.map((team) => (
                                <MenuItem
                                  key={team.companyId}
                                  value={team.companyId}
                                >
                                  {team.displayName}
                                </MenuItem>
                              ))}
                          </Select>
                          {touched.teamId && (
                            <FormHelperText>{errors.teamId}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary">
                          *Note: After selecting a team, please change the price
                          group accordingly. The correct price group can be
                          selected by logging into the selected team.*
                        </Typography>
                      </Grid>
                    </Grid>
                  )} */}

                {/* Charger Category Section */}
                {userType.toUpperCase() === "ROOT" &&
                  companyType.toUpperCase() === "GP" && (
                    <Box sx={{ mb: 3 }}>
                      <Card
                        sx={{
                          p: 3,
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          border: "1px solid rgba(0,0,0,0.05)",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 2,
                            display: "flex",
                            alignItems: "center",
                            "&::before": {
                              content: '""',
                              width: 4,
                              height: 24,
                              backgroundColor: "primary.main",
                              borderRadius: 2,
                              mr: 2,
                            },
                          }}
                        >
                          Charger Category
                        </Typography>

                        <FormControl
                          component="fieldset"
                          error={Boolean(
                            touched.charger_category && errors.charger_category
                          )}
                          sx={{ width: "100%" }}
                        >
                          <FormLabel
                            component="legend"
                            sx={{
                              mb: 2,
                              fontSize: "0.875rem",
                              fontWeight: 600,
                              color: "text.primary",
                            }}
                          >
                            Select Charger Category *
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-label="charger-category"
                            name="charger_category"
                            value={values.charger_category || "paid"}
                            onChange={(e) =>
                              handleFieldChange(
                                "charger_category",
                                e.target.value
                              )
                            }
                            sx={{ gap: 3 }}
                          >
                            <FormControlLabel
                              value="paid"
                              control={
                                <Radio
                                  sx={{
                                    color: "primary.main",
                                    "&.Mui-checked": {
                                      color: "primary.main",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    Paid Charging
                                  </Typography>
                                </Box>
                              }
                              disabled={isReadOnly}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "0.875rem",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="free"
                              control={
                                <Radio
                                  sx={{
                                    color: "success.main",
                                    "&.Mui-checked": {
                                      color: "success.main",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    Free Charging
                                  </Typography>
                                </Box>
                              }
                              disabled={isReadOnly}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "0.875rem",
                                },
                              }}
                            />
                          </RadioGroup>
                          {touched.charger_category && errors.charger_category && (
                            <FormHelperText error sx={{ mt: 1, ml: 0 }}>
                              {errors.charger_category}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Card>
                    </Box>
                  )}

                {/* Connectors Section */}
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1.5,
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 700,
                        color: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        "&::before": {
                          content: '""',
                          width: 4,
                          height: 24,
                          backgroundColor: "primary.main",
                          borderRadius: 2,
                          mr: 2,
                        },
                      }}
                    >
                      Charging Connectors
                    </Typography>

                    {/* Connector Statistics */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Chip
                        label={`${values.connectors.length} Connector${
                          values.connectors.length !== 1 ? "s" : ""
                        }`}
                        color="primary"
                        variant="outlined"
                        size="small"
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.75rem",
                        }}
                      />
                      {!isCreateCharger && (
                        <Chip
                          label={`${
                            values.connectors.filter(
                              (c) => c.status === "Available"
                            ).length
                          } Available`}
                          color="success"
                          variant="outlined"
                          size="small"
                          sx={{
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        />
                      )}
                    </Box>
                  </Box>

                  <Grid container spacing={2}>
                    {values.connectors.map((value, index) => (
                      <Grid item xs={12} key={index}>
                        <Card
                          sx={{
                            p: 0,
                            borderRadius: 3,
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            border: "1px solid",
                            borderColor: "grey.200",
                            backgroundColor: "background.paper",
                            overflow: "hidden",
                            position: "relative",
                            "&:hover": {
                              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                              borderColor: "primary.light",
                              // Transform removed
                            },
                            // Transitions removed
                          }}
                        >
                          {/* Connector Header */}
                          <Box
                            sx={{
                              background:
                                "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                              p: 2,
                              color: "white",
                              position: "relative",
                              overflow: "hidden",
                              "&::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                right: 0,
                                width: "100px",
                                height: "100%",
                                background:
                                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                                transform: "translateX(100px)",
                                transition: "transform 0.6s ease",
                              },
                              "&:hover::before": {
                                transform: "translateX(-100px)",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                position: "relative",
                                zIndex: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: "rgba(255,255,255,0.2)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backdropFilter: "blur(10px)",
                                  }}
                                >
                                  <Icon
                                    icon="eva:flash-outline"
                                    width={20}
                                    height={20}
                                    style={{ color: "white" }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "middle",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "1.1rem",
                                      color: "white",
                                      mb: 0.5,
                                    }}
                                  >
                                    Connector {index + 1}
                                  </Typography>
                                  {/* <Typography
                                    variant="caption"
                                    sx={{
                                      color: 'rgba(255,255,255,0.8)',
                                      fontSize: '0.75rem',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                    }}
                                  >
                                    {value.connectorType || 'No Type Selected'}
                                  </Typography> */}
                                </Box>
                              </Box>

                              {/* Right-aligned buttons container */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                {/* UPI QR Button - First */}
                                {!isCreateCharger && (
                                  <LoadingButton
                                    size="small"
                                    type="button"
                                    variant="contained"
                                    startIcon={
                                      value.hasOwnProperty("qrCodeUrl") &&
                                      !is.empty(value.qrCodeUrl) ? (
                                        getIcon(downloadFill, 14, 14)
                                      ) : (
                                        <Icon
                                          icon="eva:plus-circle-fill"
                                          width={14}
                                          height={14}
                                        />
                                      )
                                    }
                                    onClick={() => {
                                      if (
                                        value.hasOwnProperty("qrCodeUrl") &&
                                        !is.empty(value.qrCodeUrl)
                                      ) {
                                        // Download existing QR code
                                        handleShowRazorPayQRCode(
                                          value.qrCodeUrl
                                        );
                                      } else {
                                        // Generate new QR code
                                        generateQRCode(value.connector_pk);
                                      }
                                    }}
                                    sx={{
                                      background:
                                        "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                                      border: "2px solid rgba(255,255,255,0.3)",
                                      color: "white",
                                      fontWeight: 700,
                                      fontSize: "0.7rem",
                                      px: 2,
                                      py: 0.75,
                                      borderRadius: 2,
                                      textTransform: "none",
                                      height: 36,
                                      minWidth: 110,
                                      boxShadow:
                                        "0 4px 15px rgba(46, 125, 50, 0.4)",
                                      "&:hover": {
                                        background:
                                          "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)",
                                        border:
                                          "2px solid rgba(255,255,255,0.5)",
                                        boxShadow:
                                          "0 6px 20px rgba(46, 125, 50, 0.6)",
                                        transform: "translateY(-1px)",
                                      },
                                    }}
                                  >
                                    {value.hasOwnProperty("qrCodeUrl") &&
                                    !is.empty(value.qrCodeUrl)
                                      ? "UPI QR"
                                      : "Generate UPI QR"}
                                  </LoadingButton>
                                )}

                                {/* Status Indicator - Second */}
                                {!isCreateCharger &&
                                  value.hasOwnProperty("status") && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        background: "rgba(255,255,255,0.15)",
                                        backdropFilter: "blur(10px)",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 8,
                                          height: 8,
                                          borderRadius: "50%",
                                          backgroundColor:
                                            value?.status === "Unavailable" ||
                                            value?.status === "Faulted"
                                              ? "#ffcdd2"
                                              : value?.status === "Available" ||
                                                value?.status === "Preparing"
                                              ? "#c8e6c9"
                                              : "#ffe0b2",
                                          boxShadow: `0 0 8px ${
                                            value?.status === "Unavailable" ||
                                            value?.status === "Faulted"
                                              ? "rgba(244, 67, 54, 0.5)"
                                              : value?.status === "Available" ||
                                                value?.status === "Preparing"
                                              ? "rgba(76, 175, 80, 0.5)"
                                              : "rgba(255, 152, 0, 0.5)"
                                          }`,
                                        }}
                                      />
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          color: "white",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {value?.status || "--"}
                                      </Typography>
                                    </Box>
                                  )}
                              </Box>
                            </Box>
                          </Box>

                          {/* Connector Content */}
                          <Box sx={{ p: 3 }}>
                            {/* Enhanced Form Fields - Full Width Layout */}
                            <Grid
                              container
                              spacing={1.5}
                              alignItems="flex-start"
                            >
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Connector Name
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field
                                    name={`connectors[${index}].connectorName`}
                                  >
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <TextField
                                        disabled={isReadOnly}
                                        placeholder="Enter connector name"
                                        size="small"
                                        {...field}
                                        error={
                                          touched.connectors &&
                                          errors.connectors
                                        }
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontWeight: 500,
                                            color: "text.secondary",
                                          },
                                        }}
                                      />
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Price Group
                                  </Typography>
                                </Box>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={
                                    touched.connectors && errors.connectors
                                  }
                                >
                                  <Field
                                    name={`connectors[${index}].priceGroupId`}
                                  >
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <>
                                        <Select
                                          disabled={isReadOnly}
                                          {...field}
                                          displayEmpty
                                          sx={{
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                          }}
                                        >
                                          <MenuItem value="">
                                            <em style={{ color: "#999" }}>
                                              Select Price Group
                                            </em>
                                          </MenuItem>
                                          {priceGroups &&
                                            priceGroups.map((group) => (
                                              <MenuItem
                                                key={group.priceGroupId}
                                                value={group.priceGroupId}
                                              >
                                                {group.name}
                                              </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.priceGroupId && (
                                          <FormHelperText>
                                            {errors.priceGroupId}
                                          </FormHelperText>
                                        )}
                                        {field.value && (
                                          <PriceGroupPriceDisplay
                                            priceGroupId={field.value}
                                          />
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Connector Type
                                  </Typography>
                                </Box>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={
                                    touched.connectors && errors.connectors
                                  }
                                >
                                  <Field
                                    name={`connectors[${index}].connectorType`}
                                  >
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <>
                                        <Select
                                          disabled={isReadOnly}
                                          {...field}
                                          displayEmpty
                                          sx={{
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                          }}
                                        >
                                          <MenuItem value="">
                                            <em style={{ color: "#999" }}>
                                              Select Connector Type
                                            </em>
                                          </MenuItem>
                                          {ConnectorType.map((connector) => (
                                            <MenuItem
                                              key={connector.id}
                                              value={connector.value}
                                            >
                                              {connector.type}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                        {touched.connectors && (
                                          <FormHelperText>
                                            {errors.connectors}
                                          </FormHelperText>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6} sm={3} md={1.5}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Power (kW)
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field name={`connectors[${index}].kw`}>
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <TextField
                                        disabled={isReadOnly}
                                        placeholder="0.0"
                                        size="small"
                                        {...field}
                                        error={
                                          touched.connectors &&
                                          errors.connectors
                                        }
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 600,
                                                  color: "primary.main",
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                kW
                                              </Typography>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontWeight: 500,
                                            color: "text.secondary",
                                          },
                                        }}
                                      />
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6} sm={3} md={1.5}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Voltage (V)
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field name={`connectors[${index}].volt`}>
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <TextField
                                        disabled={isReadOnly}
                                        placeholder="0"
                                        size="small"
                                        {...field}
                                        error={
                                          touched.connectors &&
                                          errors.connectors
                                        }
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 600,
                                                  color: "primary.main",
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                V
                                              </Typography>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontWeight: 500,
                                            color: "text.secondary",
                                          },
                                        }}
                                      />
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              {/* Action Buttons */}
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    justifyContent: "center",
                                    alignItems: "flex-end",
                                    height: "100%",
                                  }}
                                >
                                  {values.connectors.length > 1 &&
                                    isCreateCharger && (
                                      <Tooltip
                                        title="Remove Connector"
                                        placement="top"
                                        arrow
                                      >
                                        <LoadingButton
                                          size="small"
                                          type="button"
                                          variant="contained"
                                          onClick={() =>
                                            handleAddAndDeleteConnectors(index)
                                          }
                                          sx={{
                                            backgroundColor: "error.main",
                                            color: "white",
                                            minWidth: "auto",
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            "&:hover": {
                                              backgroundColor: "error.dark",
                                              // Transform removed
                                              boxShadow:
                                                "0 4px 12px rgba(244, 67, 54, 0.3)",
                                            },
                                            // Transitions removed
                                          }}
                                        >
                                          <Icon
                                            icon={TrashOutline}
                                            width={18}
                                            height={18}
                                          />
                                        </LoadingButton>
                                      </Tooltip>
                                    )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                    {/* Add Connector Button */}
                    {values.connectors.length !== 4 && isCreateCharger && (
                      <Grid item xs={12}>
                        <Card
                          sx={{
                            p: 1.5,
                            borderRadius: 3,
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            border: "2px dashed rgba(76, 175, 80, 0.3)",
                            background:
                              "linear-gradient(135deg, rgba(76, 175, 80, 0.02) 0%, rgba(102, 187, 106, 0.02) 100%)",
                            cursor: "pointer",
                            "&:hover": {
                              borderColor: "rgba(76, 175, 80, 0.5)",
                              background:
                                "linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(102, 187, 106, 0.05) 100%)",
                              boxShadow: "0 8px 25px rgba(76, 175, 80, 0.15)",
                            },
                          }}
                        >
                          <Box
                            onClick={() => handleAddAndDeleteConnectors()}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              textAlign: "center",
                              cursor: "pointer",
                              py: 1.5,
                            }}
                          >
                            <Box
                              sx={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                background:
                                  "linear-gradient(135deg, #4caf50 0%, #66bb6a 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 1.5,
                                boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                              }}
                            >
                              <Icon
                                icon={PlusFill}
                                width={24}
                                height={24}
                                style={{ color: "white" }}
                              />
                            </Box>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: 700,
                                color: "#4caf50",
                                mb: 0.5,
                                fontSize: "0.9rem",
                              }}
                            >
                              Add Another Connector
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                opacity: 0.8,
                                fontSize: "0.75rem",
                              }}
                            >
                              Click to add more charging connectors to this
                              station
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                {/* Additional Information Section */}
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: "primary.main",
                      mb: 1.5,
                      display: "flex",
                      alignItems: "center",
                      "&::before": {
                        content: '""',
                        width: 4,
                        height: 24,
                        backgroundColor: "primary.main",
                        borderRadius: 2,
                        mr: 2,
                      },
                    }}
                  >
                    Additional Information
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Description"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("description")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Admin Address"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("adminAddress")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Additional Notes"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("note")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          border: "1px solid",
                          borderColor: "grey.300",
                          backgroundColor: "background.paper",
                          "&:hover": {
                            borderColor: "primary.main",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          },
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              {...getFieldProps("showOnPortal")}
                              checked={!!values.showOnPortal}
                              disabled={isReadOnly}
                              onChange={(event) => {
                                const isPublic = event.target.checked;
                                setFieldValue("showOnPortal", isPublic);
                              }}
                              sx={{
                                "& .MuiSwitch-switchBase.Mui-checked": {
                                  color: "primary.main",
                                },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                  {
                                    backgroundColor: "primary.main",
                                  },
                              }}
                            />
                          }
                          label={
                            <Box>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600, color: "text.primary" }}
                              >
                                Make Charger Public
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: "text.secondary" }}
                              >
                                Allow this charger to be visible on the public
                                portal
                              </Typography>
                            </Box>
                          }
                          labelPlacement="end"
                          sx={{ alignItems: "flex-start", m: 0 }}
                        />
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>

              <TabPanel value="address">
                <Box sx={{ width: "100%", maxWidth: "100%" }}>
                  {/* Header Section */}
                  <Box
                    sx={{
                      mb: 2,
                      p: 2,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                      border: "1px solid rgba(25, 118, 210, 0.1)",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        }}
                      >
                        <Icon
                          icon="eva:map-outline"
                          width={24}
                          height={24}
                          color="white"
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 0.5,
                          }}
                        >
                          Location & Address
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                          }}
                        >
                          Configure charger location, amenities, and contact
                          information
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Main Content */}
                  <Grid container spacing={2}>
                    {/* Map Section */}
                    <Grid item xs={12} lg={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:map-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Location Map
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Select the exact location of your charging station
                          </Typography>
                        </Box>

                        <Map
                          onPlaces={handlePlacesChanged}
                          lat={values.locationLatitude}
                          lng={values.locationLongitude}
                          address={values.street}
                          showMessage={true}
                        />
                      </Card>
                    </Grid>

                    {/* Location Details Section */}
                    <Grid item xs={12} lg={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:navigation-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Coordinates
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Precise location coordinates for the charging
                            station
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <TextField
                            label="Latitude"
                            size="medium"
                            type="number"
                            inputProps={{
                              step: "0.00000001",
                              min: -90,
                              max: 90,
                            }}
                            {...getFieldProps("locationLatitude")}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setFieldValue("locationLatitude", "");
                                return;
                              }
                              const numValue = parseFloat(value);
                              if (!isNaN(numValue)) {
                                const roundedValue =
                                  Math.round(numValue * 100000000) / 100000000;
                                setFieldValue(
                                  "locationLatitude",
                                  roundedValue.toString()
                                );
                              }
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />

                          <TextField
                            label="Longitude"
                            size="medium"
                            type="number"
                            inputProps={{
                              step: "0.00000001",
                              min: -180,
                              max: 180,
                            }}
                            {...getFieldProps("locationLongitude")}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setFieldValue("locationLongitude", "");
                                return;
                              }
                              const numValue = parseFloat(value);
                              if (!isNaN(numValue)) {
                                const roundedValue =
                                  Math.round(numValue * 100000000) / 100000000;
                                setFieldValue(
                                  "locationLongitude",
                                  roundedValue.toString()
                                );
                              }
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />
                        </Stack>
                      </Card>
                    </Grid>

                    {/* Amenities Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:star-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Nearby Amenities
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Select amenities available near the charging station
                          </Typography>
                        </Box>

                        <FormControl fullWidth>
                          <InputLabel
                            id="amenities-label"
                            sx={{ fontWeight: 500 }}
                          >
                            Select Amenities
                          </InputLabel>
                          <Select
                            labelId="amenities-label"
                            id="amenities-select"
                            multiple
                            {...getFieldProps("amenities")}
                            input={
                              <OutlinedInput
                                id="select-multiple-chip"
                                label="Select Amenities"
                              />
                            }
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    sx={{
                                      backgroundColor:
                                        "rgba(25, 118, 210, 0.1)",
                                      color: "primary.main",
                                      fontWeight: 500,
                                      "& .MuiChip-deleteIcon": {
                                        color: "primary.main",
                                      },
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 48 * 4.5 + 8,
                                  width: 250,
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          >
                            {AMENITIES.map((am) => (
                              <MenuItem
                                key={am.value}
                                value={am.value}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "rgba(25, 118, 210, 0.04)",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(25, 118, 210, 0.08)",
                                  },
                                }}
                              >
                                {am.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Card>
                    </Grid>

                    {/* Photo Upload Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:camera-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Station Photos
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Upload photos to help users identify the location
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            border: "2px dashed rgba(25, 118, 210, 0.3)",
                            borderRadius: 3,
                            p: 2,
                            textAlign: "center",
                            background: "rgba(25, 118, 210, 0.02)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              borderColor: "rgba(25, 118, 210, 0.5)",
                              background: "rgba(25, 118, 210, 0.04)",
                            },
                          }}
                        >
                          <Stack direction="column" alignItems="center" gap={2}>
                            <Box
                              sx={{
                                width: 60,
                                height: 60,
                                borderRadius: "50%",
                                background:
                                  "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 1,
                              }}
                            >
                              <Icon
                                icon="eva:camera-outline"
                                width={30}
                                height={30}
                                color="#1976d2"
                              />
                            </Box>
                            <Typography
                              color="text.secondary"
                              textAlign="center"
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              Upload photos to help users identify the charging
                              station location
                            </Typography>
                            <LoadingButton
                              variant="contained"
                              onClick={() =>
                                imageUploadInputRef.current.click()
                              }
                              loading={imageUploadPending}
                              loadingIndicator="Uploading..."
                              startIcon={<Icon icon="eva:plus-outline" />}
                              sx={{
                                background:
                                  "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                                boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                                fontWeight: 600,
                                px: 3,
                                py: 1,
                                "&:hover": {
                                  background:
                                    "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                                  boxShadow:
                                    "0 6px 16px rgba(25, 118, 210, 0.4)",
                                  // Transform removed
                                },
                                // Transitions removed
                              }}
                            >
                              Upload Photos
                              <input
                                accept="image/jpeg,image/png,image/jpg"
                                type="file"
                                hidden
                                multiple
                                id="issue-image"
                                ref={imageUploadInputRef}
                                onChange={handleImageUpload}
                              />
                            </LoadingButton>
                          </Stack>
                        </Box>

                        {values.photos &&
                          values.photos.filter((url) => !is.empty(url)).length >
                            0 && (
                            <Box sx={{ mt: 3 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 600,
                                  color: "text.primary",
                                  mb: 2,
                                }}
                              >
                                Uploaded Photos
                              </Typography>
                              <ImageList cols={3} gap={8}>
                                {values.photos
                                  .filter((url) => !is.empty(url))
                                  .map((url, index) => (
                                    <ImageListItem key={`${url}-${index}`}>
                                      <img
                                        src={url}
                                        alt={`Station photo ${index + 1}`}
                                        style={{
                                          maxHeight: "120px",
                                          maxWidth: "100%",
                                          borderRadius: "8px",
                                          objectFit: "cover",
                                        }}
                                        loading="lazy"
                                      />
                                    </ImageListItem>
                                  ))}
                              </ImageList>
                            </Box>
                          )}
                      </Card>
                    </Grid>

                    {/* Contact Information Section */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:phone-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Contact Information
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Provide contact details for station operators
                          </Typography>
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Number 1"
                              size="medium"
                              {...getFieldProps("operator_number1")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#1976d2",
                                      borderWidth: 2,
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Number 2"
                              size="medium"
                              {...getFieldProps("operator_number2")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#1976d2",
                                      borderWidth: 2,
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Email"
                              size="medium"
                              type="email"
                              {...getFieldProps("operator_email")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#1976d2",
                                      borderWidth: 2,
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>

              <TabPanel value="settings">
                <Box sx={{ width: "100%", maxWidth: "100%" }}>
                  {/* Header Section */}
                  <Box
                    sx={{
                      mb: 2,
                      p: 2,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                      border: "1px solid rgba(25, 118, 210, 0.1)",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        }}
                      >
                        <Icon
                          icon="eva:settings-outline"
                          width={24}
                          height={24}
                          color="white"
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 0.5,
                          }}
                        >
                          Charger Settings
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                          }}
                        >
                          Configure payment options, notifications, and admin
                          settings
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Settings Sections */}
                  <Grid container spacing={2}>
                    {/* Payment Options Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:credit-card-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Payment Options
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure payment methods and access controls
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("employeeOrResident")}
                                  checked={!!values.employeeOrResident}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                      {
                                        backgroundColor: "#1976d2",
                                      },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Employee / Resident (OTP)
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Require OTP for employee/resident access
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("payWithWallet")}
                                  checked={!!values.payWithWallet}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                      {
                                        backgroundColor: "#1976d2",
                                      },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Pay With Wallet
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Allow payments using digital wallet
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("payWithCard")}
                                  checked={!!values.payWithCard}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                      {
                                        backgroundColor: "#1976d2",
                                      },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Pay With Card
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Allow payments using credit/debit cards
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                    {/* Admin Settings Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:settings-2-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Admin Settings
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure technical parameters and system behavior
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <TextField
                            required
                            disabled={isReadOnly}
                            label="Tolerance Level (Watts)"
                            size="medium"
                            {...getFieldProps("tolerance_watt")}
                            error={Boolean(
                              touched.tolerance_watt && errors.tolerance_watt
                            )}
                            helperText={
                              touched.tolerance_watt && errors.tolerance_watt
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />

                          <TextField
                            required
                            disabled={isReadOnly}
                            label="Meter Interval (Seconds)"
                            size="medium"
                            {...getFieldProps("meter_interval_sec")}
                            error={Boolean(
                              touched.meter_interval_sec &&
                                errors.meter_interval_sec
                            )}
                            helperText={
                              touched.meter_interval_sec &&
                              errors.meter_interval_sec
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("preparingState")}
                                  checked={!!values.preparingState}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                      {
                                        backgroundColor: "#1976d2",
                                      },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Preparing State
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Enable preparing state for charging sessions
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                    {/* Notification Settings Section */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:email-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Mail Notification Settings
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure email notifications for charger events
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("enableNotifications")}
                                  checked={!!values.enableNotifications}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                      {
                                        backgroundColor: "#1976d2",
                                      },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Enable Notifications
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Send email notifications for charger events
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          {values?.enableNotifications && (
                            <>
                              <TextField
                                required
                                multiline
                                rows={4}
                                label="Notification Recipients"
                                placeholder="Enter email addresses separated by commas"
                                {...getFieldProps("notificationRecipients")}
                                error={Boolean(
                                  touched.notificationRecipients &&
                                    errors.notificationRecipients
                                )}
                                helperText={
                                  touched.notificationRecipients &&
                                  errors.notificationRecipients
                                }
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "rgba(25, 118, 210, 0.02)",
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#1976d2",
                                        borderWidth: 2,
                                      },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#1976d2",
                                        borderWidth: 2,
                                      },
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontWeight: 500,
                                  },
                                }}
                              />

                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.primary",
                                    mb: 2,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Icon
                                    icon="eva:bell-outline"
                                    width={16}
                                    height={16}
                                    style={{ marginRight: "8px" }}
                                  />
                                  Notification Events
                                </Typography>

                                <Grid container spacing={2}>
                                  {[
                                    {
                                      key: "OcppStationBooted",
                                      label: "Boot Notification Sent",
                                      description: "When charger boots up",
                                    },
                                    {
                                      key: "OcppStationStatusFailure",
                                      label: "Connector Faulted",
                                      description:
                                        "When a connector gets faulted",
                                    },
                                    {
                                      key: "OcppStationWebSocketConnected",
                                      label: "Station Connected",
                                      description:
                                        "When charging station connects",
                                    },
                                    {
                                      key: "OcppStationWebSocketDisconnected",
                                      label: "Station Disconnected",
                                      description:
                                        "When charging station disconnects",
                                    },
                                    {
                                      key: "OcppTransactionStarted",
                                      label: "Transaction Started",
                                      description:
                                        "When a charging transaction starts",
                                    },
                                    {
                                      key: "OcppTransactionEnded",
                                      label: "Transaction Ended",
                                      description:
                                        "When a charging transaction stops",
                                    },
                                  ].map(({ key, label, description }) => (
                                    <Grid item xs={12} md={6} key={key}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          borderRadius: 2,
                                          border: "1px solid rgba(0,0,0,0.08)",
                                          background: "rgba(0,0,0,0.02)",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              {...getFieldProps(key)}
                                              checked={!!values[key]}
                                              sx={{
                                                "& .MuiSwitch-switchBase.Mui-checked":
                                                  {
                                                    color: "#1976d2",
                                                  },
                                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                  {
                                                    backgroundColor: "#1976d2",
                                                  },
                                              }}
                                            />
                                          }
                                          label={
                                            <Box>
                                              <Typography
                                                sx={{
                                                  fontWeight: 500,
                                                  fontSize: "0.9rem",
                                                }}
                                              >
                                                {label}
                                              </Typography>
                                              <Typography
                                                sx={{
                                                  fontSize: "0.75rem",
                                                  color: "text.secondary",
                                                }}
                                              >
                                                {description}
                                              </Typography>
                                            </Box>
                                          }
                                          sx={{
                                            m: 0,
                                            alignItems: "flex-start",
                                          }}
                                        />
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              </Box>
                            </>
                          )}
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>
              <TabPanel value="config"></TabPanel>

              <TabPanel value="logs">
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "visible",
                  }}
                >
                  {/* Search Controls */}
                  <Card
                    sx={{
                      p: 2,
                      mb: 1.5,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(0,0,0,0.05)",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          alignItems: "center",
                          flexWrap: "wrap",
                          flex: 1,
                        }}
                      >
                        <Box
                          sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}
                        >
                          <TextField
                            label="Start Date/Time"
                            type="datetime-local"
                            size="small"
                            value={formatDateForInput(timeInterval.startDate)}
                            onFocus={() => {
                              // Clear any pending blur timeout
                              if (dateInputBlurTimeoutRef.current) {
                                clearTimeout(dateInputBlurTimeoutRef.current);
                                dateInputBlurTimeoutRef.current = null;
                              }
                              setIsDateInputFocused(true);
                            }}
                            onBlur={() => {
                              // Small delay to allow date picker to close
                              dateInputBlurTimeoutRef.current = setTimeout(() => {
                                setIsDateInputFocused(false);
                                dateInputBlurTimeoutRef.current = null;
                              }, 200);
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              setTimeInterval((prev) => ({
                                ...prev,
                                startDate: value ? new Date(value) : "",
                              }));
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 600,
                                color: "#1976d2",
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#1976d2",
                              },
                            }}
                          />
                        </Box>
                        <Box
                          sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}
                        >
                          <TextField
                            label="End Date/Time"
                            type="datetime-local"
                            size="small"
                            value={formatDateForInput(timeInterval.endDate)}
                            onFocus={() => {
                              // Clear any pending blur timeout
                              if (dateInputBlurTimeoutRef.current) {
                                clearTimeout(dateInputBlurTimeoutRef.current);
                                dateInputBlurTimeoutRef.current = null;
                              }
                              setIsDateInputFocused(true);
                            }}
                            onBlur={() => {
                              // Small delay to allow date picker to close
                              dateInputBlurTimeoutRef.current = setTimeout(() => {
                                setIsDateInputFocused(false);
                                dateInputBlurTimeoutRef.current = null;
                              }, 200);
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              setTimeInterval((prev) => ({
                                ...prev,
                                endDate: value ? new Date(value) : "",
                              }));
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 600,
                                color: "#1976d2",
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#1976d2",
                              },
                            }}
                          />
                        </Box>
                        <LoadingButton
                          variant="contained"
                          loading={isLogsFetching || isLogsRefetching || isFetchingLogs}
                          loadingIndicator="Loading..."
                          disabled={isLogsFetching || isLogsRefetching || isFetchingLogs}
                          onClick={() => {
                            // Set time filter as active when user searches
                            setHasTimeFilter(true);
                            // Pass Date objects directly - fetchLogFilterData will handle UTC conversion
                            fetchLogFilterData(
                              timeInterval.startDate,
                              timeInterval.endDate
                            );
                          }}
                          sx={{
                            background:
                              "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                            boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
                            minWidth: { xs: "100%", sm: "120px" },
                            height: { xs: "40px", sm: "36px" },
                            fontSize: { xs: "0.875rem", sm: "0.8rem" },
                            fontWeight: 600,
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.4)",
                              // Transform removed
                            },
                            "&.Mui-disabled": {
                              background: "linear-gradient(135deg, #90caf9 0%, #b3e5fc 100%)",
                              color: "rgba(255, 255, 255, 0.7)",
                            },
                            // Transitions removed
                          }}
                        >
                          {isLogsFetching || isLogsRefetching || isFetchingLogs ? "Loading..." : "Search"}
                        </LoadingButton>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            // Clear time filter and reset to real-time logs
                            setHasTimeFilter(false);
                            setTimeInterval({ startDate: "", endDate: "" });
                            // Refresh logs without time filter
                            window.location.reload();
                          }}
                          sx={{
                            background:
                              "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
                            borderColor: "#9e9e9e",
                            color: "#424242",
                            minWidth: { xs: "100%", sm: "120px" },
                            height: { xs: "40px", sm: "36px" },
                            fontSize: { xs: "0.875rem", sm: "0.8rem" },
                            fontWeight: 600,
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)",
                              borderColor: "#757575",
                              color: "#212121",
                            },
                          }}
                        >
                          Clear Filter
                        </Button>
                      </Box>
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {logsData?.pages[0]?.length > 0 && (
                          <Tooltip title="Export CSV">
                            <span>
                              <IconButton
                                onClick={handleExport}
                                sx={{
                                  bgcolor: "success.main",
                                  color: "white",
                                  "&:hover": {
                                    bgcolor: "success.dark",
                                  },
                                }}
                              >
                                <Icon
                                  icon={downloadFill}
                                  width={20}
                                  height={20}
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                        <Tooltip title="Refresh data">
                          <span>
                            <IconButton
                              onClick={handleRefetch}
                              disabled={isLogsFetching || isLogsRefetching || isFetchingLogs}
                              sx={{
                                bgcolor: "primary.main",
                                color: "white",
                                "&:hover": {
                                  bgcolor: "primary.dark",
                                },
                                "&:disabled": {
                                  bgcolor: "grey.300",
                                  color: "grey.500",
                                },
                              }}
                            >
                              <Icon icon={RefreshFill} width={20} height={20} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Stack>
                  </Card>

                  {/* Enhanced Logs Content */}
                  {logDetailData?.pages?.[0]?.length > 0 || logsData?.pages?.[0]?.length > 0 ? (
                    <Box
                      sx={{
                        borderRadius: 3,
                        overflow: "visible",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <EnhancedLogsData
                        data={logDetailData}
                        fetchNextPage={fetchNextPage}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        hasTimeFilter={hasTimeFilter}
                      />
                    </Box>
                  ) : isLogsFetching || isLogsRefetching || isFetchingLogs ? (
                    <Card
                      sx={{
                        p: 4,
                        textAlign: "center",
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mx: "auto",
                          mb: 1.5,
                        }}
                      >
                        <Icon
                          icon="eva:loader-outline"
                          width={40}
                          height={40}
                          style={{ color: "#1976d2" }}
                        />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "#1976d2",
                          mb: 1,
                        }}
                      >
                        Loading...
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          opacity: 0.8,
                        }}
                      >
                        Fetching logs, please wait
                      </Typography>
                    </Card>
                  ) : (
                    <Card
                      sx={{
                        p: 4,
                        textAlign: "center",
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mx: "auto",
                          mb: 1.5,
                        }}
                      >
                        <Icon
                          icon="eva:file-text-outline"
                          width={40}
                          height={40}
                          style={{ color: "#1976d2" }}
                        />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "#1976d2",
                          mb: 1,
                        }}
                      >
                        No Logs Found
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          opacity: 0.8,
                        }}
                      >
                        Try adjusting your date range or search criteria
                      </Typography>
                    </Card>
                  )}
                </Box>
              </TabPanel>

              <TabPanel value="operating_instruction">
                <Grid container spacing={2} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      FAQ
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12} textAlign="right">
                    {values?.faq?.length !== 10 && (
                      <Grid item xs={12} lg={12} sm={12}>
                        <Tooltip
                          title="Add More Connectors"
                          placement="right-end"
                        >
                          <LoadingButton
                            size="medium"
                            type="button"
                            variant="contained"
                            onClick={() => handleAddAndDeleteFAQ()}
                          >
                            <Icon
                              icon={PlusFill}
                              fontSize="1.9em"
                              className="fs-5"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                  {values?.faq?.map((value, i) => (
                    <Fragment key={`faq-${i}`}>
                      <Grid item xs={6} lg={6}>
                        <Stack direction="column" gap={2}>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].id`}>
                              {({ field }) => (
                                <input type="hidden" {...field} />
                              )}
                            </Field>
                            <Field name={`faq[${i}].question`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  disabled={isReadOnly}
                                  label={`Question-${i + 1}`}
                                  size="small"
                                  {...field}
                                  error={touched.question && errors.question}
                                />
                              )}
                            </Field>
                          </FormControl>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].answer`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  multiline
                                  rows={4}
                                  id=""
                                  label={`Answer-${i + 1}`}
                                  error={touched.answer && errors.answer}
                                  {...field}
                                />
                              )}
                            </Field>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </Fragment>
                  ))}
                </Grid>
              </TabPanel>

              <TabPanel value="report_incidents">
                <Grid container spacing={2} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      REPORT INCIDENTS
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <BaseTable
                      rows={values.report_issues ?? []}
                      columns={reportIssuesColumn}
                      loading={isFetching}
                      getRowId={(row) => row.serial_number}
                      showExportCsvBtn={false}
                      csvMorphemes="chargers"
                      pageSize={10}
                      isReadOnly={isReadOnly}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              {!hideForTabs.includes(selectedTab) && (
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  {!isReadOnly && (
                    <>
                      <Button
                        size="medium"
                        type="button"
                        variant="outlined"
                        component={RouterLink}
                        to="/charger"
                        startIcon={<Icon icon="eva:close-outline" />}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        Cancel
                      </Button>
                      <LoadingButton
                        size="medium"
                        type="submit"
                        variant="contained"
                        disabled={isReadOnly}
                        loading={isSubmitting || isLoading}
                        startIcon={<Icon icon="eva:save-outline" />}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        {isSubmitting || isLoading
                          ? "Saving..."
                          : "Save Changes"}
                      </LoadingButton>
                    </>
                  )}
                </Stack>
              )}
            </Form>
          </FormikProvider>

          {razorPayQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={razorPayQRCodePreview}
              buttonsArray={
                razorPayQRCodePreview.type === "upi"
                  ? [
                      {
                        btnLabel: "Download",
                        action: () => downloadUPIQRFromModal(razorPayQRCodePreview.value, razorPayQRCodePreview.logoUrl),
                        params: false,
                      },
                      {
                        btnLabel: "Close",
                        action: function () {
                          setRazorPayQRCodePreview({ ...razorPayQRCodePreview, open: false });
                        },
                      },
                    ]
                  : razorPayQRCodePreview.buttons
              }
            />
          )}
          {CMQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={CMQRCodePreview}
              buttonsArray={CMQRCodePreview.buttons}
            />
          )}
          <TabPanel value="remote operations">
            <Box sx={{ width: "100%", maxWidth: "100%" }}>
              {/* Header Section */}
              <Box
                sx={{
                  mb: 2,
                  p: 3,
                  borderRadius: 3,
                  background:
                    "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                  border: "1px solid rgba(25, 118, 210, 0.1)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                    }}
                  >
                    <Icon
                      icon="eva:settings-outline"
                      width={24}
                      height={24}
                      color="white"
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        color: "primary.main",
                        mb: 0.5,
                      }}
                    >
                      Remote Operations
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        fontWeight: 500,
                      }}
                    >
                      Control and manage charger operations remotely
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Main Content */}
              <Grid container spacing={2}>
                {/* Operation Selection Panel */}
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(0,0,0,0.05)",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      height: "fit-content",
                    }}
                  >
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "text.primary",
                          mb: 1,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          icon="eva:radio-button-on-outline"
                          width={20}
                          height={20}
                          style={{ marginRight: "8px" }}
                        />
                        Select Operation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.875rem",
                        }}
                      >
                        Choose the operation you want to perform
                      </Typography>
                    </Box>

                    <FormControl fullWidth>
                      <RadioGroup
                        aria-labelledby="Remote-Operations-Radio-Btns-Group-Label"
                        onChange={(event, newValue) => {
                          setOperation(newValue);
                        }}
                        value={operation}
                        name="remote-operations-radio-buttons-group"
                        sx={{ gap: 1 }}
                      >
                        {remoteOperations &&
                          remoteOperations.map(({ label, value }) => (
                            <FormControlLabel
                              key={value}
                              value={value}
                              control={
                                <Radio
                                  sx={{
                                    color: "primary.main",
                                    "&.Mui-checked": {
                                      color: "primary.main",
                                    },
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 20,
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "0.9rem",
                                    color: "text.primary",
                                  }}
                                >
                                  {label}
                                </Typography>
                              }
                              sx={{
                                m: 0,
                                p: 1.5,
                                borderRadius: 2,
                                border: "1px solid transparent",
                                // Transitions removed
                                "&:hover": {
                                  backgroundColor: "rgba(25, 118, 210, 0.04)",
                                  borderColor: "rgba(25, 118, 210, 0.1)",
                                },
                                "&.Mui-checked": {
                                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                                  borderColor: "rgba(25, 118, 210, 0.2)",
                                },
                              }}
                            />
                          ))}
                      </RadioGroup>
                    </FormControl>
                  </Card>
                </Grid>

                {/* Operation Form Panel */}
                <Grid item xs={12} md={8}>
                  {operation && validationSchema && !is.empty(initialValues) && (
                    <Card
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        minHeight: "400px",
                      }}
                    >
                      <Box sx={{ mb: 1.5 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            color: "text.primary",
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            icon="eva:edit-outline"
                            width={20}
                            height={20}
                            style={{ marginRight: "8px" }}
                          />
                          Operation Configuration
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "0.875rem",
                          }}
                        >
                          Configure parameters for the selected operation
                        </Typography>
                      </Box>

                      <RemoteOperationForm
                        operation={operation}
                        validationSchema={validationSchema}
                        initialValues={initialValues}
                        chargerId={values.chargepoint_id}
                        chargerPk={id}
                        key={operation}
                        queryKeysDropdown={queryKeysDropdown}
                      />
                    </Card>
                  )}

                  {/* Empty State */}
                  {(!operation ||
                    !validationSchema ||
                    is.empty(initialValues)) && (
                    <Card
                      sx={{
                        p: 3,
                        textAlign: "center",
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        minHeight: "400px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1.5,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                        }}
                      >
                        <Icon
                          icon="eva:settings-outline"
                          width={40}
                          height={40}
                          color="#1976d2"
                        />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "text.primary",
                          mb: 1,
                        }}
                      >
                        Select an Operation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          maxWidth: "300px",
                        }}
                      >
                        Choose a remote operation from the left panel to
                        configure and execute it
                      </Typography>
                    </Card>
                  )}
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </Card>
      </TabContext>
      {modalOpen && remoteOperationPerformed && (
        <RemoteOpsStatusModal
          open={modalOpen}
          onClose={handleRemoteOpsStatusModalClose}
          operation={
            remoteOperations.find(
              (operation) => operation.value === remoteOperationPerformed
            ).label
          }
          responseRow={
            operationDetails.response
              ? [
                  {
                    id: 1,
                    charge_box_id: operationDetails.chargerId,
                    response: operationDetails.response.response,
                    error: operationDetails.response.errorMessage,
                    details: operationDetails.response.details,
                  },
                ]
              : [
                  {
                    id: 1,
                    charge_box_id: operationDetails.chargerId,
                    response: "",
                    error: "",
                    details: "",
                  },
                ]
          }
        />
      )}
    </>
  );
}
